import React from 'react'
import { debounce } from 'lodash'

const formatEmailSearch = (term) => term ? 'email ^= "' + term + '"' : ''
const formatUsernameSearch = (term) => term ? 'username ^= "' + term + '"' : ''
const formatFirstNameSearch = (term) => term ? 'given_name ^= "' + term + '"' : ''
const formatLastNameSearch = (term) => term ? 'family_name ^= "' + term + '"' : ''

const fieldFormatters = {
  email: formatEmailSearch,
  username: formatUsernameSearch,
  firstname: formatFirstNameSearch,
  lastname: formatLastNameSearch
}

const useUserSearch = ({ term, field = 'email' }) => {
  const [searchTerm, setSearchTerm] = React.useState('')

  const debouncedSearch = React.useMemo(
    () =>
      debounce((term, field) => {
        const formatter = fieldFormatters[field] || formatEmailSearch
        setSearchTerm(formatter(term))
      }, 1000),
    [setSearchTerm]
  )

  React.useEffect(() => {
    debouncedSearch(term, field)
  }, [debouncedSearch, term, field])

  return { searchTerm }
}

export default useUserSearch
